import { createBrowserRouter, Navigate } from 'react-router-dom';

import { OrgContextRoute } from '@/components/guards/org-context-route';
import { ProtectedRoute } from '@/components/guards/protected-route';
import { SuperAdminRoute } from '@/components/guards/super-admin-route';
import { AppLayout } from '@/components/layout/app-layout';
import { ProjectLayout } from '@/components/layout/project-layout';
import { AcceptInvitePage } from '@/pages/auth/accept-invite-page';
import { ForgotPasswordPage } from '@/pages/auth/forgot-password-page';
import { LoginPage } from '@/pages/auth/login-page';
import { ResetPasswordPage } from '@/pages/auth/reset-password-page';
import { HomePage } from '@/pages/home-page';
import { NotFoundPage } from '@/pages/not-found-page';
import { OrgDashboardPage } from '@/pages/org/dashboard-page';
import { OrgProjectsPage } from '@/pages/org/projects-page';
import { OrgSettingsPage } from '@/pages/org/settings-page';
import { ProfilePage } from '@/pages/profile/profile-page';
import { IssueDetailPage } from '@/pages/project/issue-detail-page';
import { ProjectBacklogPage } from '@/pages/project/project-backlog-page';
import { ProjectBoardPage } from '@/pages/project/project-board-page';
import { ProjectDashboardPage } from '@/pages/project/project-dashboard-page';
import { ProjectIssuesPage } from '@/pages/project/project-issues-page';
import { ProjectOverviewPage } from '@/pages/project/project-overview-page';
import { ProjectSettingsPage } from '@/pages/project/project-settings-page';
import { SuperAdminDashboardPage } from '@/pages/super-admin/dashboard-page';
import { SuperAdminInvitationsPage } from '@/pages/super-admin/invitations-page';
import { SuperAdminOrganizationsPage } from '@/pages/super-admin/organizations-page';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/accept-invite/:token', element: <AcceptInvitePage /> },

  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/', element: <HomePage /> },
          { path: '/profile', element: <ProfilePage /> },

          {
            path: 'super-admin',
            element: <SuperAdminRoute />,
            children: [
              { index: true, element: <Navigate to="/super-admin/dashboard" replace /> },
              { path: 'dashboard', element: <SuperAdminDashboardPage /> },
              { path: 'organizations', element: <SuperAdminOrganizationsPage /> },
              { path: 'invitations', element: <SuperAdminInvitationsPage /> },
              { path: '*', element: <NotFoundPage /> },
            ],
          },

          {
            path: 'o/:orgSlug',
            element: <OrgContextRoute />,
            children: [
              { index: true, element: <Navigate to="dashboard" replace /> },
              { path: 'dashboard', element: <OrgDashboardPage /> },
              { path: 'projects', element: <OrgProjectsPage /> },
              { path: 'settings', element: <OrgSettingsPage /> },

              {
                path: 'projects/:projectKey',
                element: <ProjectLayout />,
                children: [
                  { index: true, element: <ProjectOverviewPage /> },
                  { path: 'issues', element: <ProjectIssuesPage /> },
                  { path: 'issues/:issueKey', element: <IssueDetailPage /> },
                  { path: 'settings', element: <ProjectSettingsPage /> },
                  { path: 'backlog', element: <ProjectBacklogPage /> },
                  { path: 'board', element: <ProjectBoardPage /> },
                  { path: 'dashboard', element: <ProjectDashboardPage /> },
                ],
              },

              { path: '*', element: <NotFoundPage /> },
            ],
          },
        ],
      },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
